const OAuthRedirectUrl = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/roles';

export const environment = {
  production: false,
  API_BASE_URL: `${$ENV.API_BASE_URL}`,
  authUrl: `${$ENV.AUTH_URL}`,
  OAuthRedirectUrl,
  OAuthClientId: `${$ENV.OAUTH_CLIENT_ID}`,
  OAuthSecret: `${$ENV.OAUTH_SECRET}`,
  translate: {
    defaultLanguage: `${$ENV.DEFAULT_LANGUAGE}`
  },
  casBaseUrl: `${$ENV.CAS_BASE_URL}`
};
